import * as React from 'react';

import { RealtimeAudioPlayerViewProps } from './RealtimeAudio.types';

export default function RealtimeAudioPlayerView(props: RealtimeAudioPlayerViewProps) {
  return (
    <div>
    </div>
  );
}
